module.exports = __webpack_public_path__ + "static/media/email_help.104e409e.svg";